import { render, staticRenderFns } from "./HoribaSamplesIndexComponent.vue?vue&type=template&id=65e61580"
import script from "./HoribaSamplesIndexComponent.vue?vue&type=script&lang=js"
export * from "./HoribaSamplesIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports